import React, { memo } from 'react';
import { View, Text, StyleSheet, Dimensions } from 'react-native';
import { performanceUtil } from '@qnpm/q-design-utils';
import { computeColumnColor } from '../../utils/handle';
import { PADDING_HORIZONTAL, DAY_ITEM_SPACE } from '../style';
const WeekHeader = (props) => {
    const { data, computedStyle } = props;
    let { refreshWidth } = props;
    refreshWidth = refreshWidth ? refreshWidth : Dimensions.get('window').width;
    let widthStyle = {
        width: (refreshWidth - PADDING_HORIZONTAL * 2 - DAY_ITEM_SPACE * 6) / 7
    };
    return (<View style={[styles.wrapper, computedStyle.weekHeader.wrapper]}>
            {data.map((week, index) => {
        const color = computeColumnColor(index);
        return (<View key={index} style={[
            styles.weekItem,
            computedStyle.weekHeader.weekItem,
            widthStyle
        ]}>
                        <Text style={[computedStyle.weekHeader.text, { color }]}>
                            {week}
                        </Text>
                    </View>);
    })}
        </View>);
};
export default memo(WeekHeader, performanceUtil.fastDeepEqual);
const styles = StyleSheet.create({
    wrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#FFFFFF'
    },
    weekItem: {
        justifyContent: 'center',
        alignItems: 'center'
    }
});
